import { skipToken, useQuery } from "@tanstack/react-query";
import {
  type SystemSettingType,
  postSystemGetSystemSetting,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const SYSTEM_SETTING_QUERY_KEY = "SYSTEM_SETTING";

export const systemSettingKeys = {
  all: [SYSTEM_SETTING_QUERY_KEY],
  byType: (type?: SystemSettingType) => [...systemSettingKeys.all, type],
};

export const useGetSystemSettingQuery = (type?: SystemSettingType) =>
  useQuery({
    queryKey: systemSettingKeys.byType(type),
    queryFn: type
      ? processResponseWithApiProblemDetails(() =>
          postSystemGetSystemSetting({ systemSettingType: type }),
        )
      : skipToken,
  });
